/* THIS FILE IS AUTO-GENERATED */
var IconTypes = {
  AI: 'AI',
  Accessibility: 'Accessibility',
  Account: 'Account',
  AccountsTable: 'AccountsTable',
  ActionPlanning: 'ActionPlanning',
  Active: 'Active',
  Add: 'Add',
  AddItem: 'AddItem',
  Addons: 'Addons',
  AdminGears: 'AdminGears',
  AgentPerformance: 'AgentPerformance',
  Animation: 'Animation',
  AreaChart: 'AreaChart',
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  ArrowUp: 'ArrowUp',
  AutomatedSetup: 'AutomatedSetup',
  BarChart: 'BarChart',
  Bell: 'Bell',
  BenchmarkGraph: 'BenchmarkGraph',
  Bookmark: 'Bookmark',
  BookmarkFill: 'BookmarkFill',
  Books: 'Books',
  BubbleChart: 'BubbleChart',
  BusinessImpact: 'BusinessImpact',
  Button: 'Button',
  BxLogo: 'BxLogo',
  Calendar: 'Calendar',
  CaretDown: 'CaretDown',
  CaretLeft: 'CaretLeft',
  CaretRight: 'CaretRight',
  CaretUp: 'CaretUp',
  CarryForwardChoices: 'CarryForwardChoices',
  Catalog: 'Catalog',
  Check: 'Check',
  ChevronDown: 'ChevronDown',
  ChevronLeft: 'ChevronLeft',
  ChevronRight: 'ChevronRight',
  ChevronUp: 'ChevronUp',
  Class: 'Class',
  ClearFormatting: 'ClearFormatting',
  Clock: 'Clock',
  Close: 'Close',
  ClosePanelLeft: 'ClosePanelLeft',
  ClosePanelRight: 'ClosePanelRight',
  Cloudy: 'Cloudy',
  CoachingPriorities: 'CoachingPriorities',
  CodeBrackets: 'CodeBrackets',
  ColumnFilter: 'ColumnFilter',
  Comments: 'Comments',
  ConstantSum: 'ConstantSum',
  Contact: 'Contact',
  ContactList: 'ContactList',
  Contacts: 'Contacts',
  Copy: 'Copy',
  CoreXM: 'CoreXM',
  CreditCard: 'CreditCard',
  CrossAnalytics: 'CrossAnalytics',
  CxLogo: 'CxLogo',
  Dashboard: 'Dashboard',
  DataAnalysis: 'DataAnalysis',
  DataSource: 'DataSource',
  Database: 'Database',
  DefaultChoice: 'DefaultChoice',
  DescriptiveText: 'DescriptiveText',
  Desktop: 'Desktop',
  Diamond: 'Diamond',
  Directory: 'Directory',
  DisplayLogic: 'DisplayLogic',
  DistributionSummary: 'DistributionSummary',
  DonutChart: 'DonutChart',
  Download: 'Download',
  Downvote: 'Downvote',
  DownvoteFilled: 'DownvoteFilled',
  Draft: 'Draft',
  Drag: 'Drag',
  DragAndDrop: 'DragAndDrop',
  Drilldown: 'Drilldown',
  EXCOVIDReturnToWork: 'EXCOVIDReturnToWork',
  EXCOVIDSolution: 'EXCOVIDSolution',
  EditorGeneric: 'EditorGeneric',
  EllipsisHorizontal: 'EllipsisHorizontal',
  EllipsisVertical: 'EllipsisVertical',
  EmojiColorAngry: 'EmojiColorAngry',
  EmojiColorHappiest: 'EmojiColorHappiest',
  EmojiColorHappy: 'EmojiColorHappy',
  EmojiColorNotGreat: 'EmojiColorNotGreat',
  EmojiColorOK: 'EmojiColorOK',
  EmojiColorPrettyGood: 'EmojiColorPrettyGood',
  EmojiColorSad: 'EmojiColorSad',
  EmojiColorUnhappy: 'EmojiColorUnhappy',
  EmojiMonoAngry: 'EmojiMonoAngry',
  EmojiMonoHappiest: 'EmojiMonoHappiest',
  EmojiMonoHappy: 'EmojiMonoHappy',
  EmojiMonoNotGreat: 'EmojiMonoNotGreat',
  EmojiMonoOK: 'EmojiMonoOK',
  EmojiMonoPrettyGood: 'EmojiMonoPrettyGood',
  EmojiMonoUnhappy: 'EmojiMonoUnhappy',
  Employee360: 'Employee360',
  EmployeeAdHoc: 'EmployeeAdHoc',
  EmployeeEngagement: 'EmployeeEngagement',
  EmployeeLifecycle: 'EmployeeLifecycle',
  EmployeePulse: 'EmployeePulse',
  EmptyBox: 'EmptyBox',
  EnvelopeClosed: 'EnvelopeClosed',
  EnvelopeOpened: 'EnvelopeOpened',
  EnvelopeOptedOut: 'EnvelopeOptedOut',
  Error: 'Error',
  EventTrigger: 'EventTrigger',
  ExLogo: 'ExLogo',
  ExampleProject: 'ExampleProject',
  Exclude: 'Exclude',
  ExclusiveAnswer: 'ExclusiveAnswer',
  ExternalLink: 'ExternalLink',
  EyeDropper: 'EyeDropper',
  Feedback: 'Feedback',
  File: 'File',
  Filter: 'Filter',
  Fingerprint: 'Fingerprint',
  Flag: 'Flag',
  Folder: 'Folder',
  FontSize: 'FontSize',
  FormField: 'FormField',
  GaugeChart: 'GaugeChart',
  Globe: 'Globe',
  GraphicSlider: 'GraphicSlider',
  HamburgerMenu: 'HamburgerMenu',
  HealthWellness: 'HealthWellness',
  HeatMap: 'HeatMap',
  Help: 'Help',
  HighVolume: 'HighVolume',
  Highlight: 'Highlight',
  Home: 'Home',
  Hotspot: 'Hotspot',
  Hyperlink: 'Hyperlink',
  Image: 'Image',
  ImportedData: 'ImportedData',
  Inactive: 'Inactive',
  IncompleteTranslations: 'IncompleteTranslations',
  IndentMore: 'IndentMore',
  Information: 'Information',
  InlineQuestion: 'InlineQuestion',
  Integration: 'Integration',
  Intercept: 'Intercept',
  JoinInner: 'JoinInner',
  JoinLeftOuter: 'JoinLeftOuter',
  JoinOuter: 'JoinOuter',
  JoinRightOuter: 'JoinRightOuter',
  JourneyMap: 'JourneyMap',
  Libraries: 'Libraries',
  LibraryLink: 'LibraryLink',
  LightBulb: 'LightBulb',
  LineChart: 'LineChart',
  ListBullets: 'ListBullets',
  ListChecked: 'ListChecked',
  ListNumbers: 'ListNumbers',
  Lock: 'Lock',
  LogicTree: 'LogicTree',
  LookAndFeel: 'LookAndFeel',
  LoopAndMerge: 'LoopAndMerge',
  LowerCase: 'LowerCase',
  Marker: 'Marker',
  MatrixTable: 'MatrixTable',
  Maximize: 'Maximize',
  Megaphone: 'Megaphone',
  Merge: 'Merge',
  Metadata: 'Metadata',
  Microphone: 'Microphone',
  MicrophoneMute: 'MicrophoneMute',
  Minimize: 'Minimize',
  MobileLandscape: 'MobileLandscape',
  MobilePortrait: 'MobilePortrait',
  Move: 'Move',
  MultipleChoice: 'MultipleChoice',
  NPS: 'NPS',
  NewCustomer: 'NewCustomer',
  NewTemplate: 'NewTemplate',
  NotInFlow: 'NotInFlow',
  OnlinePanel: 'OnlinePanel',
  OpenPanelLeft: 'OpenPanelLeft',
  OpenPanelRight: 'OpenPanelRight',
  OrgHierarchy: 'OrgHierarchy',
  Pages: 'Pages',
  PaginateFilter: 'PaginateFilter',
  PaintBrush: 'PaintBrush',
  PaintBucket: 'PaintBucket',
  PaperClip: 'PaperClip',
  Paragraph: 'Paragraph',
  ParticipantInviteAutomation: 'ParticipantInviteAutomation',
  ParticipantPortal: 'ParticipantPortal',
  PartlyCloudy: 'PartlyCloudy',
  PasswordLock: 'PasswordLock',
  Pause: 'Pause',
  PauseCircle: 'PauseCircle',
  Pencil: 'Pencil',
  PickGroupRank: 'PickGroupRank',
  PieChart: 'PieChart',
  Pin: 'Pin',
  PinTo: 'PinTo',
  PipedText: 'PipedText',
  Play: 'Play',
  Presentation: 'Presentation',
  Printer: 'Printer',
  PrivateData: 'PrivateData',
  Program: 'Program',
  Project: 'Project',
  ProjectBar: 'ProjectBar',
  Publish: 'Publish',
  PxLogo: 'PxLogo',
  QRCode: 'QRCode',
  QuestionBlock: 'QuestionBlock',
  Rainy: 'Rainy',
  RecodedValues: 'RecodedValues',
  Redo: 'Redo',
  ReferenceBlock: 'ReferenceBlock',
  Refresh: 'Refresh',
  RemoveItem: 'RemoveItem',
  RemoveLink: 'RemoveLink',
  Report: 'Report',
  ReputationManagement: 'ReputationManagement',
  ReusableChoices: 'ReusableChoices',
  RichTextEditor: 'RichTextEditor',
  Risk: 'Risk',
  Roles: 'Roles',
  SMS: 'SMS',
  Save: 'Save',
  Scheduled: 'Scheduled',
  SchemaData: 'SchemaData',
  SchemaEditor: 'SchemaEditor',
  ScreenCapture: 'ScreenCapture',
  Search: 'Search',
  Segment: 'Segment',
  SelectColumn: 'SelectColumn',
  Send: 'Send',
  SentenceCase: 'SentenceCase',
  Settings: 'Settings',
  Share: 'Share',
  SharedFolder: 'SharedFolder',
  Shuffle: 'Shuffle',
  SideBySide: 'SideBySide',
  Signature: 'Signature',
  Skip: 'Skip',
  Slider: 'Slider',
  SliderOptions: 'SliderOptions',
  SmallCaps: 'SmallCaps',
  SocialResponse: 'SocialResponse',
  SortAlphabeticAscending: 'SortAlphabeticAscending',
  SortAlphabeticDescending: 'SortAlphabeticDescending',
  SortNumberAscending: 'SortNumberAscending',
  SortNumberDescending: 'SortNumberDescending',
  SpecialCharacters: 'SpecialCharacters',
  StarFilled: 'StarFilled',
  StarHalf: 'StarHalf',
  StarOutlined: 'StarOutlined',
  StarRanking: 'StarRanking',
  StatsAnalysis: 'StatsAnalysis',
  Stormy: 'Stormy',
  StrategicAccounts: 'StrategicAccounts',
  Student: 'Student',
  Subscript: 'Subscript',
  Subtract: 'Subtract',
  Success: 'Success',
  Sunny: 'Sunny',
  Superscript: 'Superscript',
  Survey: 'Survey',
  SurveyComplete: 'SurveyComplete',
  SurveyDirector: 'SurveyDirector',
  SurveyExpired: 'SurveyExpired',
  SurveyIQ: 'SurveyIQ',
  SurveyInvite: 'SurveyInvite',
  Table: 'Table',
  TableAppend: 'TableAppend',
  Tablet: 'Tablet',
  Tag: 'Tag',
  Teacher: 'Teacher',
  Template: 'Template',
  TextAlignCenter: 'TextAlignCenter',
  TextAlignJustified: 'TextAlignJustified',
  TextAlignLeft: 'TextAlignLeft',
  TextAlignRight: 'TextAlignRight',
  TextAnalysis: 'TextAnalysis',
  TextBold: 'TextBold',
  TextColor: 'TextColor',
  TextColorLetter: 'TextColorLetter',
  TextColorSwatch: 'TextColorSwatch',
  TextEntry: 'TextEntry',
  TextItalic: 'TextItalic',
  TextStrikeThrough: 'TextStrikeThrough',
  TextUnderline: 'TextUnderline',
  ThirdPartyQuestion: 'ThirdPartyQuestion',
  ThreeSixtyProject: 'ThreeSixtyProject',
  ThumbsDown: 'ThumbsDown',
  ThumbsUp: 'ThumbsUp',
  Tickets: 'Tickets',
  Timing: 'Timing',
  Tools: 'Tools',
  Transaction: 'Transaction',
  Translation: 'Translation',
  Trash: 'Trash',
  Undo: 'Undo',
  Union: 'Union',
  UniqueLink: 'UniqueLink',
  Unlink: 'Unlink',
  Unlock: 'Unlock',
  Unpin: 'Unpin',
  Upload: 'Upload',
  UpperCase: 'UpperCase',
  Upvote: 'Upvote',
  UpvoteFilled: 'UpvoteFilled',
  User: 'User',
  UserGroup: 'UserGroup',
  Validation: 'Validation',
  VariableNaming: 'VariableNaming',
  Video: 'Video',
  ViewOff: 'ViewOff',
  ViewOn: 'ViewOn',
  VocalizeDashboard: 'VocalizeDashboard',
  Volume: 'Volume',
  VolumeMute: 'VolumeMute',
  WaffleMenu: 'WaffleMenu',
  Warning: 'Warning',
  Webhook: 'Webhook',
  WhatsApp: 'WhatsApp',
  Widgets: 'Widgets',
  Workflows: 'Workflows',
  WorkingFromHome: 'WorkingFromHome'
};

export { IconTypes as default };
